import { useEffect } from 'react';

export function useRunOnce(callback) {
    // Deliberately omit any dependency list to make sure this hook only
    // ever runs once when the component is mounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(callback, []);
}
